import { cn } from "@/lib/cn";
import { useI18n } from "@/i18n/use-i18n";
import type { DealBucket } from "@/api/types";

const BUCKET_CLASS: Record<DealBucket, string> = {
  done: "bg-ok-wash text-ok",
  sig: "bg-teal-wash text-teal-deep",
  open: "bg-warn-wash text-warn",
};

export function StatusPill({ bucket }: { bucket: DealBucket }) {
  const { t } = useI18n();
  return (
    <span
      className={cn(
        "inline-block rounded-full px-2.5 py-1 text-[12px] font-semibold whitespace-nowrap",
        BUCKET_CLASS[bucket],
      )}
    >
      {t(`status.${bucket}`)}
    </span>
  );
}

/** Neutral tag, e.g. a product's "Phase 1" or a pricing mode. */
export function Tag({ children, muted = false }: { children: string; muted?: boolean }) {
  return (
    <span
      className={cn(
        "inline-block rounded-full px-2.5 py-0.5 text-[11.5px] font-semibold whitespace-nowrap",
        muted ? "bg-line-soft text-muted" : "bg-teal-wash text-teal-deep",
      )}
    >
      {children}
    </span>
  );
}
